<template>
  <div class="crm-workspace-nav">
    <nav aria-label="Sales workspace" class="d-flex ga-1 flex-wrap">
      <v-btn v-for="item in primary" :key="item.path" :to="item.path" :prepend-icon="item.icon"
        :variant="group === item.group ? 'tonal' : 'text'" :color="group === item.group ? 'primary' : undefined" size="small">{{ item.label }}</v-btn>
    </nav>
    <nav v-if="views.length" aria-label="Workspace views" class="d-flex ga-1 mt-2 flex-wrap">
      <v-btn v-for="item in views" :key="item.path" :to="item.path" size="small" variant="text" :color="route.path === item.path ? 'primary' : undefined">{{ item.label }}</v-btn>
      <v-menu v-if="group === 'accounts'">
        <template #activator="{ props }"><v-btn v-bind="props" size="small" variant="text" icon="mdi-dots-horizontal" aria-label="More account tools" /></template>
        <v-list><v-list-item to="/crm/imports" title="Import accounts" prepend-icon="mdi-file-upload-outline" /></v-list>
      </v-menu>
    </nav>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { usePermissionsStore } from '@/stores/permissions'
const route = useRoute()
const permissions = usePermissionsStore()
const group = computed(() => ['/sales-orders', '/order-requests'].includes(route.path) ? 'orders' : /\/crm\/(accounts|pipeline|imports)/.test(route.path) ? 'accounts' : 'today')
const primary = [
  { path: '/crm/today', label: 'Today', icon: 'mdi-checkbox-marked-circle-outline', group: 'today' },
  { path: '/crm/accounts', label: 'Accounts', icon: 'mdi-store-outline', group: 'accounts' },
  { path: '/sales-orders', label: 'Orders & deliveries', icon: 'mdi-truck-delivery-outline', group: 'orders' }
]
const views = computed(() => group.value === 'today' ? [
  { path: '/crm/today', label: 'My day' }, { path: '/crm/calendar', label: 'Week' }, { path: '/crm/dashboard', label: 'Results' }
] : group.value === 'accounts' ? [
  { path: '/crm/accounts', label: 'All accounts' }, { path: '/crm/pipeline', label: 'Pipeline' }
] : [
  { path: '/sales-orders', label: 'Orders & deliveries' }, { path: '/order-requests', label: 'Customer requests', permission: 'crm.view' }
].filter((item) => !item.permission || permissions.hasPermission(item.permission)))
</script>
<style scoped>
.crm-workspace-nav { max-width: 1440px; margin: 0 auto 20px; padding: 8px 12px 12px; border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity)); }
</style>
